/* eslint-disable import/prefer-default-export */
export const setOrderExperiences = value => ({
    type: 'SET_ORDER_EXPERIENCES',
    value
});
